import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';

import { useAppContext } from '@app/contexts';
import { makeRequest, parseJSON, setAxiosHeaders } from '@app/utils';
import { invokePathPrefix, Route, UserSession } from '@app/constants';

export const LogoutPage: FC = () => {
  const navigate = useNavigate();
  const { setPatronSession } = useAppContext();

  const samlLogoutMutation = useMutation(['samlLogout'], () =>
    makeRequest({
      url: `${invokePathPrefix}/saml/logout`,
      method: 'POST',
      withCredentials: true,
    }).finally(() => {
      sessionStorage.removeItem(UserSession.patron);
      setAxiosHeaders(parseJSON(sessionStorage.getItem(UserSession.guest), {}));
      setPatronSession(null);
      navigate(Route.search);
    })
  );

  useEffect(() => {
    samlLogoutMutation.mutate();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [samlLogoutMutation.mutate]);

  return null;
};
